import React, { useState, useEffect } from 'react';
import { Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import NoxTable from '../../component/Table';
import {
  fetchEmailSubscriptions,
  downloadEmailSubscription
} from '../../actions/emailSubscriptionAction';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const EmailSubscription = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const subscriptions = useSelector(({ subscription }) => subscription.subscriptions);
  const currentProject = useSelector(({ project }) => project.currentProject);

  const onDownloadCsv = () => {
    dispatch(downloadEmailSubscription());
  };

  const onEmailDelete = () => {};

  const mapToTable = (subscriptions) => {
    const data = [];

    subscriptions?.forEach(({ _id, email, subscribedAt, type }, index) => {
      data.push({
        email,
        id: _id,
        key: index,
        subscribedAt: formatDate(subscribedAt),
        type
      });
    });

    return data;
  };

  const columns = [
    {
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        return <Copy text={type} />;
      },
      sorter: (a, b) => a.type.localeCompare(b.type),
      title: 'Type'
    },
    {
      dataIndex: 'email',
      key: 'email',
      render: (email) => {
        return <Copy text={email} />;
      },
      sorter: (a, b) => a.email.toString().localeCompare(b.email),
      title: 'Email'
    },
    {
      dataIndex: 'subscribedAt',
      key: 'subscribedAt',
      render: (subscribedAt) => {
        return <Copy text={subscribedAt} />;
      },
      sorter: (a, b) => new Date(a.subscribedAt) - new Date(b.subscribedAt),
      title: 'Subscribed At'
    },
    {
      key: 'edit',
      render: () => {
        return <Tag>edit</Tag>;
      }
    }
  ];

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download .CSV',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onEmailDelete,
      title: 'Delete'
    });
  }

  useEffect(() => {
    async function load() {
      dispatch(fetchEmailSubscriptions());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const data = mapToTable(subscriptions);

  if (!currentProject) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="Email Subscriptions" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default EmailSubscription;
